module.exports = __webpack_public_path__ + "img/skiCapitalNew.ab168b0c.jpeg";